import 'jquery'
import * as ko from "knockout"
import * as bootbox from 'bootbox'
import { ElementLocationViewModel } from './ElementLocationViewModel';
import { SignatureViewModel } from './SignatureViewModel';

class CanvasElement {
    constructor(private row: number, private column: number, private viewModel: any) {
    }
}

export class AccountViewModel {
    isSignedIn: KnockoutObservable<boolean>;
    accessToken: string;

    imagesOffset: number;
    imagesLimit: number;
    imagesIsDone: boolean;

    fieldCodes: KnockoutObservableArray<string>;

    signatureID: number;
    signatureName: string;

    isLoadingXinkSignatures: KnockoutObservable<boolean>;
    xinkSignatures: KnockoutObservableArray<SignatureViewModel>;

    isUploading: KnockoutObservable<boolean>;
    isSuccess: KnockoutObservable<boolean>;
    errorMessage: KnockoutObservable<string>;

    constructor() {
        this.isSignedIn = ko.observable(false);
        this.imagesOffset = 0;
        this.imagesLimit = 100;
        this.imagesIsDone = false;
        this.fieldCodes = ko.observableArray([
            "DisplayName",
            "FirstName",
            "Email",
            "Mobile",
            "Phone",
            "JobTitle",
            "WebSite"
        ]);
        this.signatureID = 0;

        this.isLoadingXinkSignatures = ko.observable(false);
        this.xinkSignatures = ko.observableArray([]);

        this.isUploading = ko.observable(false);
        this.isSuccess = ko.observable(false);
        this.errorMessage = ko.observable("");

        const self = this;
        this.errorMessage.subscribe(newvalue => {
            if (newvalue !== "") {
                window.setTimeout(function () {
                    self.errorMessage("");
                }, 5000);
            }
        });
    }

    signin(oAuthAuthorizeUri: string) {
        window.open(oAuthAuthorizeUri);
    }

    signinCallback(accessToken: string) {
        this.accessToken = accessToken;
        this.isSignedIn(true);
        this.errorMessage("");
        this.isSuccess(false);
        this.getFields();
    }

    loadSignatures(createSignatureFromJson: (metadata: string) => void) {
        this.signatureID = 0;
        const self = this;
        self.isLoadingXinkSignatures(true);
        self.xinkSignatures.removeAll();
        console.log(this.accessToken);
        $.ajax({
            url: "/api/signatures",
            method: "GET",
            data: { AccessToken: this.accessToken }
        }).done(function (data) {
            self.xinkSignatures.removeAll();
            for (const signature of data) {
                console.log(signature);
                self.xinkSignatures.push(new SignatureViewModel(createSignatureFromJson, signature.signatureID, signature.name, signature.metadata));
            }
        }).always(function () {
            self.isLoadingXinkSignatures(false);
        });


        $("#load-signature-modal").modal();
    }

    saveSignature() {
        const viewModels: CanvasElement[] = this.getViewModels();
        if (viewModels.length > 0) {
            if (this.signatureID == 0) {
                const self = this;
                bootbox.prompt("What do you want to call your signature?", function (enteredSignatureName: string) {
                    if (enteredSignatureName == null) {
                        return;
                    }

                    self.signatureName = enteredSignatureName;
                    self.doUpload(self, viewModels);
                });
            }
            else {
                this.doUpload(this, viewModels);
            }
        }
    }

    getImages(callback: (imageUrls: string[], isDone: boolean) => void) {
        if (this.imagesIsDone || !this.isSignedIn()) {
            return;
        }

        const self = this;
        $.ajax({
            url: "/api/images",
            method: "GET",
            data: { AccessToken: this.accessToken, Offset: this.imagesOffset, Limit: this.imagesLimit }
        }).done(function (data) {
            self.imagesIsDone = data.isDone;
            self.imagesOffset = data.offset + data.limit;

            let imageUrls: string[] = data.items.map(item => item.relativeImageUrl);
            callback(imageUrls, self.imagesIsDone);
        });
    }

    getSignature(callback: (jsonModel: string) => void, signatureId: string) {
        $.ajax({
            url: "/api/getsignature",
            method: "GET",
            data: { AccessToken: this.accessToken, SignatureId: signatureId }
        }).done(function (data) {
            console.log(data);
            callback(data.data.metadata);
        });
    }

    private getViewModels() {
        const viewModels: CanvasElement[] = [];
        const rows = $("#canvas tr");
        $.each(rows, (rowindex, row) => {
            const columns = $("td", row);
            $.each(columns, (columnindex, column) => {
                const isBound = !!ko.dataFor(column);
                if (isBound) {
                    const viewModel: ElementLocationViewModel = ko.dataFor(column);
                    let data = {};
                    viewModel.getData(data);
                    viewModels.push(new CanvasElement(rowindex, columnindex, data));
                }
            });
        });

        return viewModels;
    }

    private getFields() {
        if (!this.isSignedIn()) {
            return;
        }

        const self = this;
        $.ajax({
            url: "/api/fields",
            method: "GET",
            data: { AccessToken: this.accessToken }
        }).done(function (data) {
            self.fieldCodes(data.fields.map(item => item.code));
        });
    }

    private showGeneralError(self: AccountViewModel) {
        self.isSuccess(false);
        self.errorMessage("Something went wrong. Please login and try again.");
        self.isSignedIn(false);
        self.signatureID = 0;
        self.signatureName = "";
        self.accessToken = "";
    }

    private doUpload(self: AccountViewModel, viewModels: CanvasElement[]) {
        if (viewModels.length > 0) {
            self.isUploading(true);
            self.isSuccess(false);
            self.errorMessage("");

            const json = ko.toJSON(viewModels);

            $.ajax({
                url: "api/signature",
                method: "POST",
                data: {
                    AccessToken: self.accessToken,
                    CanvasElementsJson: json,
                    SignatureId: self.signatureID,
                    SignatureName: self.signatureName,
                }
            }).done(function (data) {
                if (data.isSuccess) {
                    self.signatureID = data.signatureID;
                    self.isSuccess(true);
                    self.errorMessage("");
                }
                else {
                    self.isSuccess(false);
                    if (data.isUniqueNameError) {
                        self.errorMessage("You already have a signature named '" + self.signatureName + "'. Please try again with a different name.");
                    }
                    else if (data.isMissingSignatureError) {
                        self.signatureID = 0;
                        self.errorMessage("There was an error. This most likely happened because you tried to update a signature that has been removed. Please try again.");
                    }
                    else {
                        self.showGeneralError(self);
                    }
                }
            }).fail(function (jqXHR, errorTextStatus, error) {
                self.showGeneralError(self);
            }).always(function () {
                self.isUploading(false);
            });
        }
    }

}



// WEBPACK FOOTER //
// ./code/AccountViewModel.ts